import { UpcheckPage } from "./UpcheckPage"

export default UpcheckPage;